import { useRef } from 'react';
import './useHorizontalScroll.css'

const useHorizontalScroll = () => {
  const scrollRef = useRef(null);

  const scrollLeft = (amount = 360) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -amount, behavior: 'smooth' });
    }
  };

  const scrollRight = (amount = 360) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  return { scrollRef, scrollLeft, scrollRight };
};

export default useHorizontalScroll;
